import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b4c2b786"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "data-radius",
  style: {borderRadius: '4px'}
}
const _hoisted_2 = { class: "font-red line-center-value" }


import { defineComponent, defineProps } from 'vue'
import { isNullValue, getI18n } from '../utils'
const __default__ = defineComponent({
  name: 'PacakgeDataCard'
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  summaryData: {
    type: Object,
    require: true
  }
},
  setup(__props) {

const props = __props

function convertPackageType (dataLimitType: string) {
  if (dataLimitType === '1') {
    return getI18n('周期内限量', 'Data Restriction In Cycle')
  } else {
    return getI18n('单日限量', 'Data Restriction In Single Day')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_divider = _resolveComponent("el-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(isNullValue)(props.summaryData))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_el_row, {
            class: "card-row",
            gutter: 20,
            align: "middle"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_tag, {
                    type: "warning",
                    effect: "light"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(getI18n)('套餐类型', 'Type')) + ": " + _toDisplayString(convertPackageType(props.summaryData.dataLimitType)), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, {
            class: "card-row",
            gutter: 20,
            align: "middle"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 24,
                class: "line-center"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_2, _toDisplayString(props.summaryData.dataBalance), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, {
            class: "card-row",
            gutter: 20,
            align: "middle"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 24,
                class: "line-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_text, { class: "mx-1" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(getI18n)('剩余高速流量', 'Remaining High-Speed Data')) + "(M)", 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_divider),
          _createVNode(_component_el_row, {
            class: "card-row",
            gutter: 20,
            align: "middle"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 11,
                class: "line-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_text, {
                    class: "mx-1 line-center-value",
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(props.summaryData.packageData), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                span: 2,
                class: "line-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_divider, { direction: "vertical" })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                span: 11,
                class: "line-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_text, {
                    class: "mx-1 line-center-value",
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(props.summaryData.refuelingData), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, {
            class: "card-row",
            gutter: 20,
            align: "middle"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 11,
                class: "line-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_text, { class: "mx-1" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(getI18n)('套餐流量', 'Package Data')) + "(M)", 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                span: 2,
                class: "line-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_divider, { direction: "vertical" })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                span: 11,
                class: "line-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_text, { class: "mx-1" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(getI18n)('加油包流量', 'Add On Data')) + "(M)", 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})